export default "__VITE_ASSET__Ok6hdFCn__"